import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "loading" }
const _hoisted_2 = { id: "loading-center" }
const _hoisted_3 = { id: "loading-center-absolute" }
const _hoisted_4 = { class: "tp-preloader-content" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-preloader-logo\"><div class=\"tp-preloader-circle\"><svg width=\"190\" height=\"190\" viewBox=\"0 0 380 380\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle stroke=\"#D9D9D9\" cx=\"190\" cy=\"190\" r=\"180\" stroke-width=\"6\" stroke-linecap=\"round\"></circle><circle stroke=\"red\" cx=\"190\" cy=\"190\" r=\"180\" stroke-width=\"6\" stroke-linecap=\"round\"></circle></svg></div><img src=\"/assets/lms_website/images/unix_logo-icon-md.jpg\" alt=\"UNIX\"></div>", 1)
const _hoisted_6 = { class: "tp-preloader-subtitle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "back-to-top-wrapper" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "back_to_top",
    type: "button",
    class: "back-to-top-btn"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "12",
      height: "7",
      viewBox: "0 0 12 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11 6L6 1L1 6",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_8 = { class: "tp-search-area" }
const _hoisted_9 = { class: "tp-search-inner p-relative" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-search-close\"><button class=\"tp-search-close-btn\"><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"path-1\" d=\"M11 1L1 11\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path class=\"path-2\" d=\"M1 1L11 11\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></button></div>", 1)
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "tp-search-wrapper" }
const _hoisted_14 = { class: "col-lg-9" }
const _hoisted_15 = { class: "tp-search-content blue" }
const _hoisted_16 = { class: "search p-relative" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", { class: "tp-search-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.3989 13.4001L16.9989 17.0001",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.3999 8.2001C15.3999 4.22366 12.1764 1.00012 8.19997 1.00012C4.22354 1.00012 1 4.22366 1 8.2001C1 12.1765 4.22354 15.4001 8.19997 15.4001C12.1764 15.4001 15.3999 12.1765 15.3999 8.2001Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_19 = {
  key: 0,
  class: "tp-search-course-title"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = {
  key: 0,
  class: "col-12"
}
const _hoisted_22 = {
  class: "alert alert-warning mb-3",
  style: {"padding":"6px 10px"}
}
const _hoisted_23 = { class: "tp-search-course-item mb-30" }
const _hoisted_24 = { class: "tp-search-course-thumb mb-5" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "tp-search-course-content" }
const _hoisted_27 = { class: "tp-search-course-star" }
const _hoisted_28 = { class: "course-star-rating star-rating-sm" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\"><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i></div>", 1)
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i>", 5)
const _hoisted_35 = [
  _hoisted_30
]
const _hoisted_36 = { class: "tp-search-course-item-title" }
const _hoisted_37 = { class: "tp-search-course-price" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" pre loader area start "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createCommentVNode(" loading content here "),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString($setup.lms_website.__('Loading...')), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" pre loader area end "),
    _createCommentVNode(" back to top start "),
    _hoisted_7,
    _createCommentVNode(" back to top end "),
    _createCommentVNode(" search area start "),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "search",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.search.value) = $event)),
                      class: "search-input",
                      placeholder: $setup.lms_website.__('What are you looking for?')
                    }, null, 8 /* PROPS */, _hoisted_17), [
                      [_vModelText, $data.search.value]
                    ]),
                    _hoisted_18
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tp-search-course-wrap", {'form-loading':($data.search.loading)}])
                  }, [
                    (!$data.search.loading && $data.search.value.length >= 3)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_19, _toDisplayString($setup.lms_website.__('Courses Found')) + " (" + _toDisplayString($data.search.list?.length) + ")", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_20, [
                      (!$data.search.loading && !$data.search.list?.length && $data.search.value.length >= 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString($setup.lms_website.__('No courses found')), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!$data.search.loading)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.search.list, (course) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: course.name,
                              class: "col-xl-3 col-lg-4 col-sm-6"
                            }, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_router_link, {
                                    to: `/courses/view/${course.name}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: (course.image)?course.image:'/assets/lms_website/images/placeholder.jpg',
                                        alt: ""
                                      }, null, 8 /* PROPS */, _hoisted_25)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _hoisted_29,
                                      _createElementVNode("div", {
                                        class: "front-stars",
                                        style: _normalizeStyle('width:'+$options.avg_rating_width(course.avg_rating))
                                      }, _hoisted_35, 4 /* STYLE */)
                                    ])
                                  ]),
                                  _createElementVNode("h4", _hoisted_36, [
                                    _createVNode(_component_router_link, {
                                      to: `/courses/view/${course.name}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($options.clip(course.title, 55)), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    (!course.paid_course)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Free"))
                                      : _createCommentVNode("v-if", true),
                                    (course.paid_course)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString($options.format_currency(course.course_price)), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 2 /* CLASS */)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" search area end ")
  ], 64 /* STABLE_FRAGMENT */))
}